import searchTemplate from '../../templates/gift-cards/partials/search.html'
import detailsTemplate from '../../templates/gift-cards/partials/details.html'
import setValueTemplate from '../../templates/gift-cards/partials/set-value.html'
import addBalanceTemplate from '../../templates/gift-cards/partials/add-balance.html'
import serverErrorTemplate from '../../templates/gift-cards/partials/server-error.html'
import loadingTemplate from '../../templates/gift-cards/partials/loading.html'
import setValueFormLegacyComponent from '../../templates/gift-cards/components/set-value-form-legacy.html'
import addBalanceFormLegacyComponent from '../../templates/gift-cards/components/add-balance-form-legacy.html'
import valueFormComponent from '../../templates/gift-cards/components/value-form.html'

/**
 * Constants related to the workflows and workflow states of the selling and redeeming gift card modals.
 */

export const workflows = {
  SELLING: 'SELLING',
  REDEEMING: 'REDEEMING',
}

// @deprecated Use GiftCardModalState instead
export const states = {
  SELLING: 'SELLING',
  SET_VALUE: 'SET_VALUE',
  REDEEMING: 'REDEEMING',
  VIEW_DETAILS: 'VIEW_DETAILS',
  ADD_BALANCE: 'ADD_BALANCE',
  SERVER_ERROR: 'SERVER_ERROR',
  LOADING: 'LOADING',
}

export const templates = {
  SELLING: searchTemplate,
  REDEEMING: searchTemplate,
  VIEW_DETAILS: detailsTemplate,
  SET_VALUE: setValueTemplate,
  ADD_BALANCE: addBalanceTemplate,
  SERVER_ERROR: serverErrorTemplate,
  LOADING: loadingTemplate,
}

export const components = {
  COMPONENT_SET_VALUE_FORM_LEGACY: setValueFormLegacyComponent,
  COMPONENT_ADD_BALANCE_FORM_LEGACY: addBalanceFormLegacyComponent,
  COMPONENT_VALUE_FORM: valueFormComponent,
}
